/* eslint-disable no-param-reassign */
import { ProjectFileUploadField } from 'src/store/state/projects';

export const assignDistinctAndRecordStatistics = (
  fields: ProjectFileUploadField[],
  rows: string[][]
) => {
  const numColumns = fields.length;

  // maps of uniqueness by column (each represented by array index of map)
  const uniquenessTrackingMaps = fields.map<Record<string, boolean>>(
    () => ({})
  );

  // number of distinct values seen per index
  const numDistinctByHeader: number[] = new Array(numColumns).fill(0);

  const numRecordByHeader: number[] = new Array(numColumns).fill(0);

  rows.forEach((entries) => {
    entries.forEach((value, idx) => {
      // A ragged no-header row can be wider than the field list; cells beyond
      // the visible columns have no statistics to contribute to.
      if (!value || idx >= numColumns) {
        return;
      }
      const uniquenessTrackingMapForHeader = uniquenessTrackingMaps[idx];
      numRecordByHeader[idx] += 1;

      if (!uniquenessTrackingMapForHeader[value]) {
        uniquenessTrackingMapForHeader[value] = true; // add value to map so it isn't tracked more than once
        numDistinctByHeader[idx] += 1; // track that we saw a distinct value
      }
    });
  });

  fields.forEach((field, idx) => {
    field.statistics.distinct =
      (numDistinctByHeader[idx] / numRecordByHeader[idx]) * 100;
    field.statistics.records = numRecordByHeader[idx];
  });
};
